/**
 * Emerging Payments API
 * The public API for Emerging Payments.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PlacementMetadata } from './PlacementMetadata';
import { HttpFile } from '../http/http';

export class PlacementContentDef {
    'id': string;
    'contentType': string;
    'contentData': any;
    'metadata'?: PlacementMetadata;

    static readonly discriminator: string | undefined = "contentType";

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "contentType",
            "baseName": "contentType",
            "type": "string",
            "format": ""
        },
        {
            "name": "contentData",
            "baseName": "contentData",
            "type": "any",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "PlacementMetadata",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PlacementContentDef.attributeTypeMap;
    }
    
    public constructor() {
        this.contentType = "PlacementContentDef";
    }
}

